import React, { useState, useRef } from 'react';

const ImageUpload = ({ onImageUpload, currentImage = null, placeholder = "Bild hochladen" }) => {
  const [dragActive, setDragActive] = useState(false);
  const [preview, setPreview] = useState(currentImage);
  const fileInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const handleFile = (file) => {
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageDataUrl = e.target.result;
        setPreview(imageDataUrl);
        if (onImageUpload) {
          onImageUpload(file, imageDataUrl);
        }
      };
      reader.readAsDataURL(file);
    } else {
      alert('Bitte wählen Sie eine Bilddatei aus.');
    }
  };

  const openFileDialog = () => {
    fileInputRef.current?.click();
  };

  const removeImage = () => {
    setPreview(null);
    if (onImageUpload) {
      onImageUpload(null, null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className="form-group">
      <label className="form-label">Event Bild</label>
      
      {preview ? (
        <div className="position-relative">
          <img 
            src={preview} 
            alt="Preview" 
            className="image-preview w-100"
            style={{ maxHeight: '300px', objectFit: 'cover', borderRadius: '8px' }}
          />
          <button
            type="button"
            className="btn btn-danger btn-sm position-absolute"
            style={{ top: '10px', right: '10px' }}
            onClick={removeImage}
          >
            ✕ Entfernen
          </button>
        </div>
      ) : (
        <div
          className={`file-upload ${dragActive ? 'dragover' : ''}`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          onClick={openFileDialog}
        >
          <div className="upload-icon">🐕</div>
          <div className="upload-text">
            <strong>{placeholder}</strong>
            <br />
            Klicken Sie hier oder ziehen Sie ein Bild hierher
            <br />
            <small className="text-muted">JPG, PNG oder GIF (max. 5MB)</small>
          </div>
        </div>
      )}
      
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ImageUpload;
